import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/IMT_logo.png';
import './legal.css';

/**
 * Placeholder privacy policy page (audit 2026-05-17).
 * Real content to be supplied by IMT International Trading AG Legal / Datenschutz.
 * The route exists so the login page can link to it as required by
 * Art. 13 GDPR.
 */
function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <img src={logo} alt="IMT" className="legal-page__logo" />
      <div className="legal-page__card">
        <div className="legal-page__branding">
          <h1 className="legal-page__company">IMT International Trading AG</h1>
          <h2 className="legal-page__title">Datenschutzerklarung / Privacy Policy</h2>
        </div>
        <div className="legal-page__body">
          <p>
            The full privacy policy for the IMT International Trading AG Hamster 4.0 platform is
            being finalised by the Legal / Datenschutz team and will be published
            here.
          </p>
          <p>
            In the meantime, please direct any data-protection enquiries
            (including requests under Articles 15 to 22 GDPR) to the contact
            address below.
          </p>
        </div>
        <div className="legal-page__contact">
          Data Protection contact: to be confirmed by Legal
        </div>
        <Link to="/login" className="legal-page__back">
          Back to login
        </Link>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
